import { render, staticRenderFns } from "./ProductSideSheetActionBar.vue?vue&type=template&id=002273e3&scoped=true"
import script from "./ProductSideSheetActionBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductSideSheetActionBar.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProductSideSheetActionBar.vue?vue&type=style&index=0&id=002273e3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002273e3",
  null
  
)

export default component.exports